import type { Locale } from '@gr/core/platform/user-preferences/locales';
import type { Dictionary } from '../shared/i18n/i18n';
import * as app from './i18n';
import * as channels from '../contexts/distribution/channels/i18n';
import * as entities from '../contexts/content/entities/i18n';
import * as identity from '../contexts/accounts/identity/i18n';
import * as media from '../contexts/content/media/i18n';
import * as plans from '../contexts/accounts/plans/i18n';
import * as posts from '../contexts/content/posts/i18n';
import * as publishing from '../contexts/distribution/publishing/i18n';
import * as scheduling from '../contexts/distribution/scheduling/i18n';
import * as system from '../contexts/platform/system/i18n';
import * as config from '../contexts/platform/config/i18n';
import * as admin from '../contexts/platform/admin/i18n';
import * as preferences from '../contexts/platform/user-preferences/i18n';
import * as workspaces from '../contexts/accounts/workspaces/i18n';
import * as tasks from '../contexts/platform/tasks/i18n';
import * as operations from '../contexts/platform/operations/i18n';

// Словари собираются из контекстов. Русский — эталон: английский каждого
// контекста объявлен с типом русского, пропуск ключа — ошибка компиляции.
const parts = [app, system, config, admin, preferences, identity, workspaces, entities, posts, media, channels, scheduling, publishing, plans, tasks, operations];

function merge(locale: Locale): Dictionary {
  return Object.assign({}, ...parts.map((part) => part[locale])) as Dictionary;
}

export const MESSAGES: Readonly<Record<Locale, Dictionary>> = {
  ru: merge('ru' as Locale),
  en: merge('en' as Locale),
};
